import { datadogRum } from '@datadog/browser-rum-slim'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  datadogRum.init({
    applicationId: runtimeConfig.public.DD_APPLICATION_ID,
    clientToken: runtimeConfig.public.DD_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: runtimeConfig.public.DD_SERVICE,
    env: runtimeConfig.public.DD_ENV,
    version: runtimeConfig.public.DD_VERSION,
    sessionSampleRate: 1,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
  })
})
